import {TtWorkingTimeEntry} from '../../interfaces/time-tracking/tt-working-time-entry';
import {TtWorkingTimeTypeFactory} from './tt-working-time-type-factory';
import {LightEmployee} from '../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {TtWorkingTimeType} from '../../interfaces/time-tracking/tt-working-time-type';

export class TtWorkingTimeEntryFactory {

  /**
   *
   * @param ttWorkingTimeEntry
   */
  public static fromObject(ttWorkingTimeEntry: any): TtWorkingTimeEntry {
    return new class implements TtWorkingTimeEntry {
      id: number = ttWorkingTimeEntry.id;
      timeFrom: string = ttWorkingTimeEntry.time_from;
      timeTo: string = ttWorkingTimeEntry.time_to;
      employeeId: number = ttWorkingTimeEntry.employee_id;
      ttWorkingTimeTypeId: number = ttWorkingTimeEntry.tt_working_time_type_id;
      ttWorkingTimeType: any = TtWorkingTimeTypeFactory.fromObject(ttWorkingTimeEntry.tt_working_time_type);
      duration: number = ttWorkingTimeEntry.duration;
      employee: LightEmployee = LightEmployeeFactory.fromObject(ttWorkingTimeEntry.employee);
    };
  }

  /**
   *
   * @param ttWorkingTimeEntry
   */
  public static fromArray(ttWorkingTimeEntry: any[]): TtWorkingTimeEntry[] {
    return ttWorkingTimeEntry.map(TtWorkingTimeEntryFactory.fromObject);
  }

  /**
   *
   */
  public static new(): TtWorkingTimeEntry {
    return new class implements TtWorkingTimeEntry {
      duration: number;
      employee: LightEmployee;
      employeeId: number;
      id: number;
      timeFrom: string;
      timeTo: string;
      ttWorkingTimeType: TtWorkingTimeType;
      ttWorkingTimeTypeId: number;
    };
  }

}
